(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-cards"] && !Shopify.designMode) return;
  try {
    
  class HorizontalScrollCards {
    constructor(el) {
      this.section = el;
      this.track = el.querySelector('[data-hsc-track]');
      this.progressBar = el.querySelector('[data-hsc-progress]');
      this.hint = el.querySelector('[data-hsc-hint]');
      if (!this.track) return;
      this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
      this.cards = [...this.track.querySelectorAll('.hsc__card')];
      this.isMobile = window.innerWidth < 750;
      this.lastActiveY = null;
      this.frame = null;
      this.snapTimer = null;
      this.onScroll = this.onScroll.bind(this);
      this.onTrackScroll = this.onTrackScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.measure();
      this.onScroll();
    }

    measure() {
      if (!this.isMobile) return;
      this.maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.scrollRange = this.maxScroll / 1.8;
      if (!this.designMode) this.section.style.height = (window.innerHeight + this.scrollRange) + 'px';
      this.updateCards();
    }

    activeY() {
      return Math.max(0, Math.min(this.scrollRange, -this.section.getBoundingClientRect().top));
    }

    onResize() {
      const mobile = window.innerWidth < 750;
      if (mobile !== this.isMobile) {
        this.isMobile = mobile;
        this.lastActiveY = null;
        if (!mobile) {
          this.section.style.height = '';
          this.track.style.scrollSnapType = '';
          this.cards.forEach(card => card.style.removeProperty('--hsc-scale'));
          if (this.progressBar) this.progressBar.style.width = '';
          return;
        }
      }
      this.measure();
      this.lastActiveY = this.activeY();
    }

    onScroll() {
      if (!this.isMobile || this.designMode) return;
      const activeY = this.activeY();
      if (this.lastActiveY === null) {
        this.track.scrollLeft = activeY * 1.8;
      } else if (activeY !== this.lastActiveY) {
        this.track.style.scrollSnapType = 'none';
        this.track.scrollLeft += (activeY - this.lastActiveY) * 1.8;
        clearTimeout(this.snapTimer);
        this.snapTimer = setTimeout(() => {
          this.track.style.scrollSnapType = '';
        }, 150);
      }
      this.lastActiveY = activeY;
      this.onTrackScroll();
    }

    onTrackScroll() {
      if (!this.isMobile || this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateCards();
      });
    }

    updateCards() {
      if (!this.isMobile) return;
      const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      const cardWidth = this.cards[0]?.offsetWidth || 1;
      this.cards.forEach(card => {
        const rect = card.getBoundingClientRect();
        const distance = Math.abs(rect.left + rect.width / 2 - center);
        const scale = 1 - 0.28 * Math.min(1, distance / cardWidth);
        card.style.setProperty('--hsc-scale', scale.toFixed(3));
      });
      const progress = this.maxScroll ? this.track.scrollLeft / this.maxScroll : 0;
      if (this.progressBar) this.progressBar.style.width = (progress * 100) + '%';
      if (this.hint) this.hint.classList.toggle('hsc--faded', progress > 0.05);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hsc').forEach(el => new HorizontalScrollCards(el));
  });

  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('.hsc');
    if (el) new HorizontalScrollCards(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locations"] && !Shopify.designMode) return;
  try {
    
  class StoreLocations {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.cards = wrapper.querySelectorAll('.sl-card');
      this.iframe = wrapper.querySelector('.sl-map__iframe');
      this.loader = wrapper.querySelector('.sl-map__loader');
      this.loadTimeout = null;

      if (!this.cards.length) return;
      this.init();
    }

    init() {
      /* ── Status badges ── */
      this.cards.forEach(card => this.setStatus(card));

      /* ── Card click => select ── */
      this.cards.forEach(card => {
        card.addEventListener('click', e => {
          if (e.target.closest('a') || e.target.closest('button') || e.target.closest('details')) return;
          this.activate(card);
        });
      });

      /* ── Iframe load ── */
      if (this.iframe) {
        this.iframe.addEventListener('load', () => {
          if (this.loadTimeout) clearTimeout(this.loadTimeout);
          this.iframe.classList.add('sl-loaded');
          this.loader.classList.add('sl-hidden');
        });
      }

      /* ── Copy address ── */
      this.wrapper.querySelectorAll('.sl-card__btn--copy').forEach(btn => {
        btn.addEventListener('click', e => {
          e.stopPropagation();
          const addr = btn.dataset.address;
          if (!addr) return;
          navigator.clipboard.writeText(addr).then(() => {
            const original = btn.innerHTML;
            btn.classList.add('sl-copied');
            btn.querySelector('span').textContent = document.documentElement.lang === 'ar' ? 'تم النسخ!' : 'Copied!';
            setTimeout(() => {
              btn.classList.remove('sl-copied');
              btn.innerHTML = original;
            }, 2000);
          });
        });
      });

      /* ── First card active ── */
      this.activate(this.cards[0]);
    }

    activate(card) {
      this.cards.forEach(c => c.classList.remove('sl-card--active'));
      card.classList.add('sl-card--active');

      const q = card.dataset.mapQuery;
      if (q && this.iframe) {
        this.loader.classList.remove('sl-hidden');
        this.iframe.classList.remove('sl-loaded');
        this.iframe.src = `https://maps.google.com/maps?q=${encodeURIComponent(q)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

        if (this.loadTimeout) clearTimeout(this.loadTimeout);
        this.loadTimeout = setTimeout(() => {
          this.iframe.classList.add('sl-loaded');
          this.loader.classList.add('sl-hidden');
        }, 4000);
      }

      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    setStatus(card) {
      const hoursData = card.dataset.hoursData;
      const badge = card.querySelector('[data-status-badge]');
      if (!badge || !hoursData) return;

      const result = this.checkStatus(hoursData);
      if (!result) { badge.style.display = 'none'; return; }

      badge.textContent = result.text;
      badge.classList.add(result.open ? 'sl-badge--open' : 'sl-badge--closed');
    }

    checkStatus(str) {
      const shortDays = ['sun','mon','tue','wed','thu','fri','sat'];
      const longDays  = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
      const now = new Date();
      const dayIdx = now.getDay();
      const mins = now.getHours() * 60 + now.getMinutes();
      const ds = shortDays[dayIdx], dl = longDays[dayIdx];

      for (let line of str.split('\n')) {
        line = line.trim();
        if (!line) continue;
        const p = line.split(':');
        if (p.length < 2) continue;
        const dayP = p[0].trim().toLowerCase();
        const timeP = p.slice(1).join(':').trim();
        if (!this.dayHit(dayP, ds, dl)) continue;
        if (timeP.toLowerCase().includes('closed')) {
          return { open: false, text: document.documentElement.lang === 'ar' ? 'مغلق' : 'Closed' };
        }
        const ts = timeP.split('-');
        if (ts.length !== 2) continue;
        const s = this.toMins(ts[0].trim()), e = this.toMins(ts[1].trim());
        if (s === null || e === null) continue;
        const openTxt = document.documentElement.lang === 'ar' ? 'مفتوح الآن' : 'Open Now';
        const closedTxt = document.documentElement.lang === 'ar' ? 'مغلق' : 'Closed';
        if (e < s) { return { open: mins >= s || mins < e, text: (mins >= s || mins < e) ? openTxt : closedTxt }; }
        return { open: mins >= s && mins < e, text: (mins >= s && mins < e) ? openTxt : closedTxt };
      }
      return null;
    }

    dayHit(dp, ds, dl) {
      const pts = dp.split('-');
      if (pts.length === 2) return this.inRange(pts[0].trim(), pts[1].trim(), ds, dl);
      return dp.split(',').some(d => { d = d.trim(); return d === ds || d === dl; });
    }

    inRange(a, b, ds, dl) {
      const sh = ['sun','mon','tue','wed','thu','fri','sat'];
      const lo = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
      let ai = sh.indexOf(a); if (ai < 0) ai = lo.indexOf(a);
      let bi = sh.indexOf(b); if (bi < 0) bi = lo.indexOf(b);
      const ci = sh.indexOf(ds);
      if (ai < 0 || bi < 0 || ci < 0) return false;
      return ai <= bi ? (ci >= ai && ci <= bi) : (ci >= ai || ci <= bi);
    }

    toMins(s) {
      s = s.toLowerCase().replace(/\s+/g, '');
      const pm = s.includes('pm'), am = s.includes('am');
      s = s.replace('am','').replace('pm','');
      const p = s.split(':');
      let h = parseInt(p[0], 10), m = p.length > 1 ? parseInt(p[1], 10) : 0;
      if (isNaN(h)) return null;
      if (pm && h < 12) h += 12;
      if (am && h === 12) h = 0;
      return h * 60 + m;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.sl-wrapper').forEach(el => new StoreLocations(el));
  });

  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('.sl-wrapper');
    if (el) new StoreLocations(el);
  });

  } catch(e) { console.error(e); }
})();
})();
